import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuthContext } from './contexts/AuthContext';
import { LanguageProvider } from '@contexts/LanguageContext';
import { ToastProvider } from '@contexts/ToastContext';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { PublicRoute } from './components/common/PublicRoute';
import { LoadingSpinner } from '@components/common';

// Route Components
import { AuthRoutes, DashboardRoutes } from './routes';

// Layouts
import AuthLayout from './layouts/AuthLayout';
import DashboardLayout from './layouts/DashboardLayout';

// Styles
import './styles/App.scss';

const AppContent = () => {
    const { loading } = useAuthContext();

    if (loading) {
        return <LoadingSpinner message="Loading application..." />;
    }

    return (
        <Router>
            <Routes>
                {/* Public routes */}
                <Route path="/auth/*" element={
                    <PublicRoute>
                        <AuthLayout>
                            <AuthRoutes />
                        </AuthLayout>
                    </PublicRoute>
                } />

                {/* Protected routes */}
                <Route path="/*" element={
                    <ProtectedRoute>
                        <DashboardLayout>
                            <DashboardRoutes />
                        </DashboardLayout>
                    </ProtectedRoute>
                } />
            </Routes>
        </Router>
    );
};

const App = () => {
    return (
        <ToastProvider>
            <AuthProvider>
                <LanguageProvider>
                    <AppContent />
                </LanguageProvider>
            </AuthProvider>
        </ToastProvider>
    );
};

export default App;
